<template lang="pug">
v-app
  em-menu
  v-content
    v-container
      .content-area
        .desciption
          h1.display-1 注文管理
          p 注文の管理を行えます
        v-data-table.elevation-1(:headers='headers', :items='desserts')
          template(v-slot:items='props')
            td {{ props.item.name }}
            td.text-xs-right {{ props.item.calories }}
            td.text-xs-right {{ props.item.fat }}
            td.text-xs-right {{ props.item.carbs }}
            td.text-xs-right {{ props.item.protein }}
            td.text-xs-right {{ props.item.iron }}
            td.text-xs-right
              v-btn(color='warning', depressed) 編集
              v-btn(color='error', depressed) 削除
</template>
<script>
import EmMenu from '@/components/organisms/EmMenu.vue'

export default {
  name: 'item',
  components: {
    EmMenu
  },
  data () {
    return {
      headers: [
        {
          text: 'Dessert (100g serving)',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Calories', value: 'calories' },
        { text: 'Fat (g)', value: 'fat' },
        { text: 'Carbs (g)', value: 'carbs' },
        { text: 'Protein (g)', value: 'protein' },
        { text: 'Iron (%)', value: 'iron' },
        { text: '', value: 'action' }
      ],
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: '1%'
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: '1%'
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: '7%'
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: '8%'
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: '16%'
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: '0%'
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: '2%'
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: '45%'
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: '22%'
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: '6%'
        }
      ]
    }
  },
  computed: {
  },
  methods: {
  },
  created () {
  }
}
</script>
<style lang="stylus" scoped>

.content-area
  display flex
  flex-direction column

</style>
